import { EventEmitter } from 'events';
export const userEventEmitter = new EventEmitter();